import { IApplicationState } from 'shared/types/redux';

export const selectModalWindowRedirectParams = (state: IApplicationState) => state.landing.modalWindowRedirectParams;
